import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";

window.ajaxLink = "https://api.opk.ba/";
window.imagesLink = "https://images.opk.ba/";
window.uploadProductImage = window.ajaxLink + "products/uploadImagesProduct";

window.onscroll = function () {
  var oldClassName = document.body.className
    .replace("scrollDown_900", "")
    .replace("scrollDown_1200", "");
  if (window.scrollY > 900 && window.innerWidth > 768) {
    oldClassName += " scrollDown_900";
  }
  if (window.scrollY > 1200 && window.innerWidth > 768) {
    oldClassName += " scrollDown_1200";
  }

  document.body.className = oldClassName;
};

window.addBlur = function (queryElement) {
  for (var el of document.querySelectorAll(queryElement)) {
    el.className =
      el.className.replace("body_page_blur", "") + " body_page_blur";
  }
};

window.removeBlur = function (queryElement) {
  if (!queryElement) {
    queryElement = ".body_page_blur";
  }

  for (var el of document.querySelectorAll(queryElement)) {
    el.className = el.className.replace(" body_page_blur", "");
  }
};

function mouseEvent(e) {
  var shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10;
  var reff = document.referrer;
  var locc = document.location.href;

  if (
    shouldShowExitIntent &&
    document.querySelector(".exit-before-popup") &&
    (reff.indexOf("google") > 0 || reff.indexOf("facebook") > 0) &&
    locc.indexOf("/p/") > 0 &&
    !localStorage.getItem("user_data")
  ) {
    document.removeEventListener("mouseout", mouseEvent);
    document.querySelector(".exit-before-popup").classList.add("active");
    setTimeout(() => {
      document.querySelector(".ebef_window").classList.add("active");
    }, 50);
    if (window.gtag) {
      window.gtag("event", "on_before_leave");
    }
  }
}

document.addEventListener("mouseout", mouseEvent);

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
